module.exports = __webpack_public_path__ + "media/images/steps/step3-738c6fee854a81c81294fc3cf6aa1b20.svg";